<template>
  <nav :class="['navbar navbar-expand navbar-light topbar mb-4 static-top shadow',{ 'system-topbar-color' : view.systemStatus ==='commission_management' }]">
    <button class="btn btn-link d-md-none rounded-circle mr-3" @click="sidebarEvent">
      <i class="fa fa-bars"></i>
    </button>
    <!-- <router-link class="navbar-brand" to="/">
      <span class="text-white"><i class="fas fa-chevron-left"></i> 回首頁</span>
    </router-link> -->
    <!-- <topbar-search></topbar-search> -->
    <topbar-navbar></topbar-navbar>
  </nav>
</template>

<script>
import Global from '@/models/UI/Global'
// import TopbarSearch from '@/components/layouts/TopbarSearch'
import TopbarNavbar from '@/components/layouts/TopbarNavbar'

export default {
  name: "TopBar",
  components:{
    // TopbarSearch,
    TopbarNavbar
  },
  data() {
    return {
      view: {
        isToggle: true,
        systemStatus: ''
      }
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      Global.$on('systemStatus', (systemStatus) => {
        this.view.systemStatus = systemStatus;
        
      })
    },
    async sidebarEvent() {
      this.view.isToggle = !this.view.isToggle
      Global.$emit('isToggle', this.view.isToggle)
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/layouts/TopBar.vue